"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var NewCustomer = /** @class */ (function (_super) {
    __extends(NewCustomer, _super);
    function NewCustomer($view) {
        var _this = _super.call(this, $view) || this;
        _this.$fieldTypeAccount = _this.$view.find('input[type=radio][name=account_type]');
        _this.initListeners();
        return _this;
    }
    NewCustomer.prototype.initListeners = function () {
        this.$fieldTypeAccount.on('change', function () {
            if ($(this).data("name") == 'Particulier') {
                $('.divPro').addClass("d-none");
                $('#account_social_reason').prop('required', false);
                $('#company_siret').prop('required', false);
            }
            else if ($(this).data("name") == 'Professionnel') {
                $('.divPro').removeClass("d-none");
                $('#account_social_reason').prop('required', true);
                $('#company_siret').prop('required', true);
            }
        });
    };
    return NewCustomer;
}(BaseComponent_1.default));
exports.default = NewCustomer;
